import frozenChicken from '../../../../../../public/assets/recipes/frozen/product/16oz-frozen-chicken-pouch.webp'
import frozenBeef from '../../../../../../public/assets/recipes/frozen/product/16oz-frozen-beef-pouch.webp'
import frozenTurkey from '../../../../../../public/assets/recipes/frozen/product/16oz-frozen-turkey-pouch.webp'
import frozenLamb from '../../../../../../public/assets/recipes/frozen/product/16oz-frozen-lamb-pouch.webp'
import frozenDuck from '../../../../../../public/assets/recipes/frozen/product/16oz-frozen-duck-pouch.webp'
import frozenVenison from '../../../../../../public/assets/recipes/frozen/product/16oz-frozen-venison-pouch.webp'
import freezeDriedBeef from '../../../../../../public/assets/recipes/freezeDried/product/25oz-freeze-dried-beef-pouch.webp'
import freezeDriedChicken from '../../../../../../public/assets/recipes/freezeDried/product/25oz-freeze-dried-chicken-pouch.webp'
import { Proteins } from 'models/Pet'

export const frozenProducts = [
  {
    name: 'recipes-overview:select-recipes.frozen.recipes.chicken.name',
    description: 'recipes-overview:select-recipes.frozen.recipes.chicken.description',
    link: 'chicken',
    image: frozenChicken,
    imageAlt: '16oz frozen chicken pouch',
    protein: Proteins.CHICKEN
  },
  {
    name: 'recipes-overview:select-recipes.frozen.recipes.beef.name',
    description: 'recipes-overview:select-recipes.frozen.recipes.beef.description',
    link: 'beef',
    image: frozenBeef,
    imageAlt: '16oz frozen beef pouch',
    protein: Proteins.BEEF
  },
  {
    name: 'recipes-overview:select-recipes.frozen.recipes.turkey.name',
    description: 'recipes-overview:select-recipes.frozen.recipes.turkey.description',
    link: 'turkey',
    image: frozenTurkey,
    imageAlt: '16oz frozen turkey pouch',
    protein: Proteins.TURKEY
  },
  {
    name: 'recipes-overview:select-recipes.frozen.recipes.lamb.name',
    description: 'recipes-overview:select-recipes.frozen.recipes.lamb.description',
    link: 'lamb',
    image: frozenLamb,
    imageAlt: '16oz frozen lamb pouch',
    protein: Proteins.LAMB
  },
  {
    name: 'recipes-overview:select-recipes.frozen.recipes.duck.name',
    description: 'recipes-overview:select-recipes.frozen.recipes.duck.description',
    link: 'duck',
    image: frozenDuck,
    imageAlt: '16oz frozen duck pouch',
    protein: Proteins.DUCK
  },
  // {
  //   name: 'recipes-overview:select-recipes.frozen.recipes.venison.name',
  //   description: 'recipes-overview:select-recipes.frozen.recipes.venison.description',
  //   link: 'venison',
  //   image: frozenVenison,
  //   imageAlt: '16oz frozen venison pouch',
  //   protein: Proteins.VENISON
  // },
]

export const freezeDriedProducts = [
  {
    name: 'recipes-overview:select-recipes.freeze-dried.recipes.beef.name',
    description: 'recipes-overview:select-recipes.freeze-dried.recipes.beef.description',
    link: 'freeze-dried-raw-beef',
    image: freezeDriedBeef,
    imageAlt: '25oz freeze-dried beef pouch',
  },
  {
    name: 'recipes-overview:select-recipes.freeze-dried.recipes.chicken.name',
    description: 'recipes-overview:select-recipes.freeze-dried.recipes.chicken.description',
    link: 'freeze-dried-raw-chicken',
    image: freezeDriedChicken,
    imageAlt: '25oz freeze-dried chicken pouch',
  },
]
